<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="DateFrom"
      [matDatepicker]="pickerFrom"
      placeholder="Fecha desde"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
    <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
      Ingrese la fecha desde
    </mat-error>
  </mat-form-field>

  <mat-form-field class="margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="DateTo"
      [matDatepicker]="pickerTo"
      placeholder="Fecha hasta"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
    <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
      Ingrese la fecha hasta
    </mat-error>
  </mat-form-field>

  <div class="full-width">
    <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>

  <mat-checkbox class="margin-right-small" formControlName="ViewExpired"
    >Ver vencidos</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="ViewDisabled"
    >Ver deshabilitados</mat-checkbox
  >
</form>
